export const hasUCConsentForService = (serviceId: string) => {
  if (typeof window === 'undefined' || !window.UC_UI?.getServicesBaseInfo) {
    return false;
  }

  const serviceInfo = window.UC_UI.getServicesBaseInfo().find(
    (data) => data.id === serviceId
  );

  return serviceInfo?.consent?.status === true;
};
